// Shown when the realtime-gateway socket is disconnected — SAM can't send or receive while offline.
export const OfflineBanner = () => (
  <div className="mx-4 mb-1 flex-shrink-0 flex items-center gap-2 px-3 py-2 rounded-lg bg-red-500/15 border border-red-500/30 text-red-400 text-xs">
    <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse flex-shrink-0" />
    Reconnecting to SAM… hang tight, this should only take a moment.
  </div>
);
